import { useCallback, useState } from 'react';
import { useModal } from 'mui-modal-provider';
import { useNavigate } from 'react-router-dom';

import { INotification } from '../../../../../../graphql/app-level-modals/models/get-modals-data.model';
import { PurchasesWarningModal } from './purchases-warning-modal';
import { NotificationType } from '../../../../../../models/notification.models';
import { PurchasesBanModal } from './purchases-ban-modal';
import { getIncorrectPurchasesNotifications } from './utils/get-incorrect-purchases-notifications';
import { InternalLinks } from '../../../../../../constants';

export const usePurchasesConsumerBanModal = () => {
  const [isShow, setIsShow] = useState(true);
  const { showModal } = useModal();
  const navigate = useNavigate();

  const handlePurchasesConsumerBanModal = useCallback((
    notifications: INotification[], updateNotifications: (notificationIds: string[]) => void,
  ) => {
    if (isShow) {
      const incorrectPurchasesNotifications = getIncorrectPurchasesNotifications(notifications);

      if (incorrectPurchasesNotifications.length) {
        const banModalNotification = incorrectPurchasesNotifications.find(({ notificationType }) =>
          notificationType === NotificationType.USER_BLOCKED);

        if (banModalNotification) {
          const { activeOn, data } = banModalNotification;

          showModal(PurchasesBanModal, {
            startBanDate: activeOn,
            endBanDate: data!.lockedUntil,
            activeBanNotificationIds: incorrectPurchasesNotifications.map(({ id }) => id),
            updateNotifications,
          });
        } else {
          const onNavigate = () => {
            navigate(InternalLinks.ecpLocator);
          };
          showModal(PurchasesWarningModal, {
            notificationId: incorrectPurchasesNotifications[0].id,
            updateNotifications,
            onNavigate,
          });
        }

        setIsShow(false);
      }
    }
  }, [
    isShow,
    showModal,
    setIsShow,
  ]);

  return { handlePurchasesConsumerBanModal };
};
